import { HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges} from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute,NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {CalendarService} from '../../services/calender.service';
import {ArticleService} from '../../services/article.service';

import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {NewsletterService} from '../../services/newsletter.service';
import {IRule} from '../../irule';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {NgbdModalContent} from '../../dashboard/modals/calender_create_newsletter/modal1.component';

import {NgbdModalBasic} from '../../dashboard/modals/calender_invite_modal/invite_modal.component';

import {CommonService} from '../../services/common.service';


declare var $:any;
import * as moment from 'moment';
let date = moment().format('MMM Do,YYYY');

@Component({
  selector: 'app-newsletter-list',
  templateUrl: './newsletter-list.component.html',
  styleUrls: ['./newsletter-list.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class NewsletterListComponent extends BaseComponent implements OnInit ,OnDestroy,IRule {

  @HostBinding('style.width') public width: string = '100%';

  // @ViewChild(AngularMultiSelect) environmentDropdown: AngularMultiSelect;


  msg:any;
  userName='';
  navigationsType=[];
  per_page:number = 10;
  record_offset:number = 0;

  loader_image:boolean=true;

  record_empty:number =0;
 
  count:any;

  dropdownSettings = {};
  dropdownSettings2 = {};

  typeList=[
     {key:'Draft',value:'Draft'},
     {key:'Review',value:'Review'},
     {key:'Scheduled',value:'Scheduled'},
     {key:'Sent',value:'Sent'},
     {key:'External',value:'External'},
       
  ];
  orderList=[
    {key:'createdDate',value:'Created Date'},
    {key:'updatedDate',value:'Updated Date'},
    {key:'publishedDate',value:'Planned Publish Date'},
    {key:'schedule',value:'Scheduled Date'}
 ]
 selectedDate ='Updated Date';

  selectedType:any=[];
  selectedOrder:any;
  search:any;
  newsletterList:any=[];
  originalList:any;
  issearch:boolean=false;
  isDescToggle:boolean=true;
  isSelectDesc:any=' desc'

  newsletterService:any;
  url:any=AppSettings.API_ENDPOINT;
  toastr:any;
  router:any;

  token:any='';

  permissions:any=[];

  commonService:any;

  user:any;

  newsletterId:number=0;

  notification:any=[];

  source:any;
  

  openRemoveNewsletter(id){

    this.newsletterId =id;

    $('#success-popup').modal('show');


  }

  deleteNewsletter(){

     
    let data={
      token:this.token,
      reqData:{
        id:this.newsletterId, 
        archive:true,
        'page':'newsletter'
      }
     
      //offset:this.record_offset
    }


    this.articleService.removeNewsletter(data).subscribe( (res)=>{
            


      if(res.status=='success'){

        let catI = this.newsletterList.findIndex( (elm) => { return  elm.id ==  this.newsletterId});
          
        
        this.newsletterList.splice(catI,1);

        this.newsletterId =0;


      }else{
        this.newsletterId =0;
      }

    });



  }


  constructor( private articleService:ArticleService, private _coS:CommonService, private calS:CalendarService,private modalService: NgbModal ,msg:MessageService, toastr: ToastrService,homeservice:HomeService,_router: Router,private route:ActivatedRoute,private newsletter:NewsletterService) {

    super(msg,toastr,homeservice,_router);

    this.newsletterService = newsletter;
    this.toastr = toastr;
    this.msg =msg;
    this.router = _router;

    this.commonService= _coS;


    this.route.queryParams.subscribe(params =>{

      if(params.source!=undefined){
        this.source = params.source;

      }
    })

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        reqData:{ 'offset':this.record_offset, 'limit':this.per_page,'page':'newsletter',
                  'order':'updatedon'+this.isSelectDesc,source:this.source
                }
      }



     this.loader_image=true;

      this.newsletterService.newsletterData(data).subscribe( (response)=>{

        if(response.status=='success'){

        
          this.loader_image=false;

          this.user = response.user;

          this.count = response.count;
        
          this.userName=response.user.name;

          this.navigationsType=response.navigation;

          this.permissions =response.permission;

          this.notification = response.notification;

          this.broadcast_menu();


          this.newsletterList = response.newsletter;
          this.originalList = response.newsletter;

        }else{


          toastr.error('News Letter Not Found  !', '', {timeOut: 3000});
          this.router.navigate(['/login']);


        }

      })

    }catch(exec){

      toastr.error('News Letter Not Found  !', '', {timeOut: 3000});

      this.router.navigate(['/login']);
    }

  }



  hideDiv(id:any){

  
    $('#'+id).hide();
    $('.modal_backdrop_bg').hide();
  }

 
  open(i:number){


    this.calS.list_newsltters_from_calender({'token':this.token,'details':{'id':this.newsletterList[i].id}}).subscribe( (evt)=>{


       // this.newsletterList[i] = (evt.calendar[0])?evt.calendar[0].newsletters[0]:this.newsletterList[i];

       if(evt.calendar[0]!=undefined){

         const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup new_invite_popup"});

          modalRef1.componentInstance.month = evt.calendar[0].month;

          modalRef1.componentInstance.year = evt.calendar[0].year;

          modalRef1.componentInstance.newsletterI = evt.calendar[0].newsletters[0];


          modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {

            modalRef1.close();



            this.calS.add_update_newsltter_to_calender
            ({
            'token':this.token,
            'details':{
                          id:receivedEntry.id,
                          name: receivedEntry.name,
                          publish:receivedEntry.publish,
                          deadline:receivedEntry.deadline,
                          number:receivedEntry.number,
                          description:receivedEntry.description,
                          invite:receivedEntry.invite,
                          'invitenow':'true'

                      },

            }).subscribe( (evt)=>{

                 if(evt.status =='success'){

                    this.toastr.success('Newsletter invite sent successfully ', '', {timeOut: 3000});

                 }else{

                   this.toastr.success('Newsletter invite sent failed !', '', {timeOut: 3000});

                 }

                 });



         });


       }


    });


    // const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup"});

    // modalRef1.componentInstance.month = '01';

    // modalRef1.componentInstance.year = '2019';

    // modalRef1.componentInstance.newsletterI = [];


    // modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {


    // modalRef1.close();


    // });









  }


  broadcast_menu(){



    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType,currentPage:'newsletter'});


  }


  ngOnInit() {

    window.scrollTo(0, 0);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true
    };


  }

  ngAfterViewInit(){

    $(window).on("scroll", function() {


      if(this.router.url == '/newsletter'){

   



        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {

      

      

         if(this.record_empty ==0 ){

          
         // console.log('end of page',this.record_offset);

          this.record_offset+=this.per_page;
             
          this.searchList();

         }
         


        }
      }
    }.bind(this));


    $(document).ready(function(){

      //$('[data-toggle="tooltip"]').tooltip();

      $('input').blur(function(event) {
        var inputValue = this.value;
        if (inputValue) {
          this.classList.add('value-exists');
        } else {
          this.classList.remove('value-exists');
        }
      });

    });


    $('body').on('click','#shorting_box', function() {
    $("#mob-sort").show();
    $(".modal_backdrop_bg").show();
    });
    $(function() {
    $('body').on('click','.filter-close', function() {
    $("#mob-filter").hide();
    $(".modal_backdrop_bg").hide();
    });
    });

    $('body').on('click','#filter_box', function() {
    $("#mob-filter").show();
    $(".modal_backdrop_bg").show();
    });
    $('body').on('click','.sort-close', function() {
    $("#mob-sort").hide();
    $(".modal_backdrop_bg").hide();
    });






    var popOverSettings = {
      placement: 'bottom',
      trigger : 'hover',
      container: 'body',
      html: true,
      selector: '[data-toggle="popover"]', //Sepcify the selector here
      content: function () {


        var content = '#newsletter-info-'+$(this).attr("data-popover-content");

        return $(content).children(".popover-body").html();


      }
  }
 
  $('body').popover(popOverSettings);


     $(document).on('click', function (e) {
      $('[data-toggle="popover"],[data-original-title]').each(function () {
          //the 'is' for buttons that trigger popups
          //the 'has' for icons within a button that triggers a popup
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {                
              (($(this).popover('hide').data('bs.popover')||{}).inState||{}).click = false  // fix for BS 3.3.6
          }
 
      });
    });


  }

  onItemSelect(item: any) {

    this.record_offset=0;
    // this.newsletterList=[]
    this.searchList()

  }

  onItemDeSelect(item:any){
   
    this.record_offset=0;
    // this.newsletterList=[];
    this.searchList()

  }

  onSelectAll(items: any) {


    this.selectedType = items;
    this.record_offset=0;
    // this.newsletterList=[]
    this.searchList()
   
  }

  onDeSelectAll(item:any){
     
    this.selectedType = item;
    this.record_offset=0;
    // this.newsletterList=[]
    this.searchList()

  }

  sortDesc(){

   // console.log('gg');

    this.isDescToggle = false;
    this.isSelectDesc = ' asc';
    this.record_offset=0;
    // this.newsletterList=[]
    this.searchList()

  }

  sortAsc(){

   // console.log('ff');

    this.isDescToggle = true;
    this.isSelectDesc = ' desc';
    this.record_offset=0;
    // this.newsletterList=[]
    this.searchList()
  }

 

  searchList(){


    //this.loader_image=true;

   
     
     this.record_empty = 1;

     this.issearch=true;

     this.loader_image =true;


     let data={}

     data['page']='newsletter';

     data['offset']=this.record_offset;

     data['limit']=this.per_page;


     if(this.search){
       data['search'] = this.search;
     }

     if(this.selectedType){

        let categoryarr=[]
        this.selectedType.map((x)=>{
          categoryarr.push(x)
        })
        data['status'] = categoryarr;

     }

     

     if(this.selectedOrder){

     

        if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'createdDate'){

          data['order'] = 'createdon' +this.isSelectDesc;

          this.selectedDate ='Created Date';

        }else if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'updatedDate'){
         
          data['order'] = 'updatedon'+this.isSelectDesc;

          this.selectedDate ='Updated Date';

        }else if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'publishedDate'){
           
          data['order'] = 'publish' +this.isSelectDesc;

          this.selectedDate ='Planned Publish Date';
        }
        else if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'schedule'){
           
          data['order'] = 'schedule' +this.isSelectDesc;

          this.selectedDate ='Scheduled Date';

        }
        else{

          data['order'] = 'updatedon'+this.isSelectDesc;

          this.selectedDate ='Updated Date';

        }
     }else{
         data['order'] = 'updatedon'+this.isSelectDesc;
     }
     try{





      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      let data2={
        token:tokenA.token,
        reqData:data
      }

      this.newsletterService.newsletterData(data2).subscribe( (response)=>{

        if(response.status=='success'){

          this.loader_image =false;

         // console.log(response.newsletter);


        if(response.newsletter.length==0){

          this.record_empty =1;

        

          if(this.record_offset ==0){
			  
			  
            this.newsletterList = response.newsletter;
            
           
         }



        } else{

          this.record_empty =0;
		  
		  if(this.record_offset ==0){
			  
			  
			   this.newsletterList = response.newsletter;
			   
			  
		  } else{
			  
			  			  
			  
			      response.newsletter.forEach(element => {

					this.newsletterList.push(element);

				  });

			  
			  
			  
		  }
		  
		 


      




        }



        }else{
         
          this.loader_image =false;

         

        // this.toastr.error('News Letter Not Found  !', '', {timeOut: 3000});
        }

      })

    }catch(exec){

      this.loader_image =false;
      this.toastr.error('News Letter Not Found  !', '', {timeOut: 3000});
    }

  }

  clearList(){

    this.issearch=false;
    this.newsletterList = this.originalList ;
    this.search = '';
    this.selectedType = [];
    this.selectedOrder = '';

    $('.txt12').removeClass('value-exists');

  }

navigate(){
  this.router.navigate(['/calendar']);
}

openUnpublish(newsletterid){

  this.newsletterId =newsletterid;

  $('#success-popup-unpublish').modal('show');

}




statusChange(){



  let data={
    token:this.token,
    reqData:{
      id:this.newsletterId, 
      unpublish:true,
      'page':'newsletter'
    }
   
  }


  this.articleService.removeNewsletter(data).subscribe( (res)=>{
     
    if(res.status=='success'){

      let ind:number = this.newsletterList.findIndex( (elem) => {return elem.id == this.newsletterId });

      this.newsletterList[ind].status ='Unpublished';

      // this.toastr.success('News Letter Status Changed  !', '', {timeOut: 3000});

    }

   })


}

}